import React from 'react';

import { TenantCard } from '../../helpers/list-page/interfaces/list-card.interface';
import ImageWrapper from '../image-wrapper/Image-wrapper';
import { CardLogo } from './card-logo';
import Link from 'next/link';

interface CardSubTenantProps {
  card: TenantCard;
  cardIndex: number;
}
export const CardSubTenant = ({ card, cardIndex }: CardSubTenantProps) => {
  return (
    <>
      <Link
        href={card?.slug}
        key={card?.id}
        className={`group flex cursor-pointer flex-col rounded-xl focus:outline focus:outline-3 focus:outline-offset-3 focus:outline-text-light `}
      >
        {card?.image?.url ? (
          <div className="relative aspect-[1.5/1] overflow-hidden rounded-t-xl">
            <ImageWrapper
              url={card?.image?.url}
              alt={
                card?.image?.description
                  ? card?.image.description
                  : 'alt text not found'
              }
              className="object-cover"
              imgClassName="object-cover"
              fill
              width={
                card?.image?.width ? parseInt(card.image.width) : undefined
              }
              height={
                card?.image?.height ? parseInt(card.image.height) : undefined
              }
            />
            <CardLogo
              card={card}
              className="!absolute left-4 top-4 h-10 w-10 rounded-md bg-brand-white"
            />
          </div>
        ) : (
          <div className="aspect-1.5/1 flex-grow"></div>
        )}
        <div className="flex min-h-[108px] flex-1 flex-col flex-wrap rounded-b-xl bg-background-primary-light px-3 pb-4 pt-6 transition-all duration-200 lg:group-hover:bg-background-secondary">
          <div className="text-sm font-title font-bold">{card?.name}</div>
          {card?.categories?.length > 0 && (
            <span className="mt-auto inline-block w-fit rounded-[7px] border-2 border-neutral-grey-200 px-2 text-bodyxs font-bold text-text-default">
              {card?.categories?.[0].name}
            </span>
          )}
        </div>
      </Link>
    </>
  );
};
